import { render, staticRenderFns } from "./ScontrinoSemplificato.vue?vue&type=template&id=d4edd526&scoped=true&"
import script from "./ScontrinoSemplificato.vue?vue&type=script&lang=js&"
export * from "./ScontrinoSemplificato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4edd526",
  null
  
)

export default component.exports